<div class="action__container" [ngStyle]="{'transform': translate}">
  <div class="action__pulse"></div>
</div>
